import React from "react"
import { motion } from 'framer-motion'

const Button = ({ injectClass, type, children, onClick, disabled = false }) => {

    const trigger = () => {
        if (typeof onClick === 'function') onClick()
    }

    return (
        <motion.div className="relative w-full px-5 py-2" onClick={()=>!disabled && trigger()}>
            <motion.div aria-disabled={disabled} className={`${injectClass} px-4 py-2 ring-1  w-auto text-center ${type === "primary" ? 'bg-primeColor ring-primeColor font-bold hover:ring-2 hover:ring-primeColor-900 text-md cursor-pointer text-white' : type === "secondary" ? 'bg-greyColor ring-primeColor font-bold text-md hover:ring-2 hover:ring-primeColor-900 cursor-pointer text-primeColor' : type === "danger" ? "bg-[#BE3144] ring-[#BE3144] hover:ring-2 hover:ring-[red] font-bold text-md text-white cursor-pointer" : ''}`}>
                {children}
            </motion.div>
        </motion.div>
    )
}

export default Button